export default __webpack_public_path__ + "static/media/Paredes.3f7185ed.jpg";